/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";
import baustein from "baustein";
import events from "dom/events";

export const ACCORDION_CLASS = "accordion";
export const ACCORDION_CONTENT_CLASS = `${ACCORDION_CLASS}__content`;
export const ACCORDION_CONTENT_EXPANDED_CLASS = `${ACCORDION_CONTENT_CLASS}--expanded`;
export const ACCORDION_TITLE_CLASS = `${ACCORDION_CLASS}__title`;
export const ACCORDION_TITLE_ACTIVE_CLASS = `${ACCORDION_TITLE_CLASS}--active`;

/**
 * NEW ACCORDIONS MODULE.
 *
 * Overlaps in responsibility with components/accordion-container .
 * For now, this component has been created to suit the needs of components/buybuybuy-options .
 *
 * @see components/buybuybuy-options
 * @see components/buybuybuy-area
 * @see components/accordion-container
 */
export default baustein.register("accordions", {
    setupEvents(add) {
        add("click", `.${ACCORDION_TITLE_CLASS}`, this._handleAccordionAction);
    },

    /**
     * Toggles a child accordion between expanded or collapsed states. It can be specified whether
     * the target accordion should be explicitly collapsed or not, if not specified it'll just
     * toggle the target (default behaviour for click/tap events). Returns a Promise that'll
     * resolve once the expanding/collapsing animation has finished.
     *
     * @public
     * @param {Object} event An instance of Baustein's wrapper around DOM events.
     * @param {HTMLElement} title Mapping to `event.target`.
     * @param {boolean} expanded Whether we want the target explicitly expanded or not.
     * @returns {Promise}
     */
    toggleTarget(title, expanded) {
        let accordion = title.parentElement;
        let accordionName = this._getAccordionName(title);
        let content = accordion.querySelector(`.${ACCORDION_CONTENT_CLASS}`);
        let nonInteraction = true;

        if (_.isNull(expanded) || _.isUndefined(expanded)) {
            // if expanding status is not passed explicitly, then user is toggling.
            expanded = !title.classList.contains(ACCORDION_TITLE_ACTIVE_CLASS);
            nonInteraction = false;
        }

        return new Promise(resolve => {
            events
                .onTransitionEnd(
                    content,
                    () => {
                        content.style.maxHeight = expanded ? content.scrollHeight + "px" : 0;
                    },
                    200,
                    "max-height"
                )
                .then(() => {
                    if (expanded) {
                        this.emit("accordionOpened", { accordionName, nonInteraction });
                    } else {
                        this.emit("accordionClosed", { accordionName });
                    }
                    resolve();
                })
                .catch(() => {
                    console.warn(`Listening for expanding animation on '.${accordion}' failed.`);
                });

            // allow explicit control whether the accordion is expanded or not
            if (expanded) {
                content.classList.add(ACCORDION_CONTENT_EXPANDED_CLASS);
                title.classList.add(ACCORDION_TITLE_ACTIVE_CLASS);
            } else {
                content.classList.remove(ACCORDION_CONTENT_EXPANDED_CLASS);
                title.classList.remove(ACCORDION_TITLE_ACTIVE_CLASS);
            }
        });
    },

    /**
     * Wraps user interactions with accordions (clicking, tapping).
     * Delegates toggling to `toggleTarget`. Logs analytics regarding the action.
     *
     * @param {Object} event Baustein's wrapper around DOM event object.
     * @param {HTMLElement} target The element on which the event happened.
     * @returns {undefined}
     */
    _handleAccordionAction(event, target) {
        this.toggleTarget(target);
    },

    /**
     * Small util get an accordion name, making logic less verbose.
     *
     * @param {HTMLElement} title The element to get the accordion name from.
     * @returns {string}
     */
    _getAccordionName(title) {
        const dataElement = title.querySelector("[data-accordion-name]");

        if (dataElement) {
            return dataElement.dataset.accordionName;
        } else {
            return "";
        }
    }
});

